import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import TextField from '@mui/material/TextField';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../utilities/FormPageHeader';
import { FormControl, Grid, Stack, Typography } from '@mui/material';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkNumber, checkPositiveNumber } from '../utilities/FormValidation';
import Select from 'react-select';
import customStyles from 'app/shared-components/SelectCustomStyle';

const shippingTypeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.shippingTypes}`;

const ContainerTypeForm = () => {

  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.container}`;

  const [tabValue, setTabValue] = useState(0);
  const params = useParams();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [validError, setValidError] = useState({});
  const [checksubmit, setCheckSubmit] = useState(false);
  const [containerName, setContainerName] = useState("");
  const [containerUniqueCode, setContainerUniqueCode] = useState("");
  const [minimumVolume, setMinimumVolume] = useState("");
  const [maximumVolume, setMaximumVolume] = useState("");
  const [mixedMaxVolume, setMixedMaxVolume] = useState("");
  const [containerWeight, setContainerWeight] = useState("");
  const [shippingType, setShippingType] = useState("");
  const [shippingTypeOptions, setShippingTypeOptions] = useState([])
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [editData, setEditData] = useState();
  const [hideDelete, setHideDelete] = useState(true)
  const [saveDisable, setSaveDisable] = useState(true);

  const handleSubmit = async () => {
    setCheckSubmit(true);
    let model = {
      name: containerName,
      uniqueCode: containerUniqueCode,
      minVolume: minimumVolume,
      maxVolume: maximumVolume,
      mixedMaxVolume: mixedMaxVolume,
      weight: containerWeight,
      modeOfShipment: shippingType,
    };
    // let url;

    try {
      if (params.id) {
        if (containerName && containerUniqueCode && !validError.maximumVolume && !validError.mixedMaxVolume &&
          !validError.containerName && !validError.shippingType && !validError.minimumVolume && !validError.containerWeight
          && minimumVolume !== '' && maximumVolume !== '' && mixedMaxVolume !== ''
        ) {
          await OAuthService.updateData(url, params.id, model);
          setSuccessMsg("Data Updated Successfully")
          setSnackState(true);
          setTimeout(() => { navigate('/containerType'); }, 800)
        }
      } else {
        if (containerName && containerUniqueCode && shippingType && minimumVolume && maximumVolume && mixedMaxVolume &&
          !validError.containerName && !validError.shippingType  && !validError.minimumVolume && !validError.containerWeight && !validError.maximumVolume && !validError.mixedMaxVolume) {
          await OAuthService.addData(url, model);
          setSuccessMsg("Data saved Successfully")
          setSnackState(true);
          setTimeout(() => { navigate('/containerType'); }, 800)
        }
      }

    } catch (error) {
      setError(error.message)
      return;
    }
  }

  /**
     * Tab Change
   */
  function handleTabChange(event, value) {
    setTabValue(value);
  }

  const editContainerType = async () => {
    try {
      const result = await OAuthService.getEditData(url, params.id);
      const ContainerType = result.data;
      setContainerName(ContainerType.name);
      setContainerUniqueCode(ContainerType.uniqueCode);
      setMinimumVolume(ContainerType.minVolume);
      setMaximumVolume(ContainerType.maxVolume);
      setMixedMaxVolume(ContainerType.mixedMaxVolume);
      setContainerWeight(ContainerType.weight);
      setEditData(ContainerType)
      setShippingType(ContainerType.modeOfShipment)
    } catch (error) {
      console.log('error', error)
      setError(error.message)
    }
  }

  useEffect(() => {
    if (params.id) {
      editContainerType();
      setHideDelete(false)
    }
  }, []);

  const handleDelete = async () => {
    try {
      if (params.id) {
        await OAuthService.deleteData(url, params.id);
        setSuccessMsg("Data deleted Successfully")
        setSnackState(true);

      }
    } catch (error) {
      console.log('error', error)
      setError(error.message)
      return;
    }
    setTimeout(() => { navigate('/containerType') }, 800);
  }

  const handleCancel = () => {
    navigate('/containerType')
  }

  const getShippingTypes = async () => {
    try {
        const list = await OAuthService.getList(shippingTypeUrl + `?sort=code,asc&size=1000`);
        const shippingTypes = list.data?._embedded?.shippingTypes
        const shippingData = shippingTypes.map((type) => {
          return {
            value: type.code,
            label: type.shippingMethodName,
          }
        })
        setShippingTypeOptions(shippingData)
    } catch (error) {
        console.log('error', error)
        setError(error.message);
    }
  }

  useEffect(() => {
    getShippingTypes()
  }, [])

  useEffect(() => {
    if (containerName && containerUniqueCode && shippingType && (minimumVolume || minimumVolume === 0) && !validError.minimumVolume && !validError.containerWeight
      && (maximumVolume || maximumVolume === 0) && !validError.maximumVolume && (mixedMaxVolume || mixedMaxVolume === 0) && !validError.mixedMaxVolume
    ) {
      if (editData) {
        if (containerName !== editData.name || containerUniqueCode !== editData.uniqueCode || shippingType !== editData.modeOfShipment || Number(minimumVolume) !== editData.minVolume ||
          (containerWeight !== null && Number(containerWeight) !== editData.weight) || Number(maximumVolume) !== editData.maxVolume || Number(mixedMaxVolume) !== editData.mixedMaxVolume) {
          setSaveDisable(false);
        } else {
          setSaveDisable(true);
        }
      } else {

        setSaveDisable(false);
      }
    } else {
      setSaveDisable(true);
    }
  }, [containerName, containerUniqueCode, minimumVolume, containerWeight, maximumVolume, mixedMaxVolume, shippingType]);

  return (
    <div className="w-full h-full overflow-scroll">
      <FormPageHeader
        componentName="Container Type"
        handleDelete={handleDelete}
        handleSubmit={handleSubmit}
        successMsg={successMsg}
        snackState={snackState}
        breadCrumbSeperator=">"
        currentPage={params.id ? "Update Container Type" : "Add Container Type"}
        parentBreadcrumbData={[{ pageName: 'Container Type List', pageLink: '/containerType' }]}
        handleCancel={handleCancel}
        error={error}
        hideDelete={hideDelete}
        saveDisable={saveDisable}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: 'w-full border-b-1' }}
        >
          <Tab 
            label="General" 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }}
          />
        </Tabs>
      </FormPageHeader>
      <div className="p-16 sm:p-24 max-w-3xl">
        <FormControl
          // ref={formRef}
          className="flex flex-col justify-center"
        >
          <div className={tabValue !== 0 ? 'hidden' : ''}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Stack>
                  <label>*Container Unique Code</label>
                  <TextField
                    className="mb-16"
                    type="text"
                    name="containerUniqueCode"
                    required
                    value={containerUniqueCode}
                    disabled={params.id ? true : false}
                    error={(checksubmit && !containerUniqueCode) || validError.containerUniqueCode ? true : false}
                    helperText={(checksubmit && !containerUniqueCode) ? "This field is required" : validError.containerUniqueCode}
                    onChange={(e) => setContainerUniqueCode(e.target.value)}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Stack>
                  <label>*Container Name</label>
                  <TextField
                    className="mb-16"
                    type="text"
                    name="containerName"
                    required
                    value={containerName}
                    error={(checksubmit && !containerName) || validError.containerName ? true : false}
                    helperText={(checksubmit && !containerName) ? "This field is required" : validError.containerName}
                    onChange={(e) => setContainerName(e.target.value.toUpperCase())}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Stack>
                  <label>*Minimum Volume (CBM)</label>
                  <TextField
                    className="mb-16"
                    type="text"
                    name="minimumVolume"
                    required
                    value={minimumVolume}
                    error={(checksubmit && !minimumVolume ) || validError.minimumVolume ? true : false}
                    helperText={(checksubmit && !minimumVolume ) ? "This field is required" : validError.minimumVolume}
                    onChange={(e) => { setMinimumVolume(e.target.value); setValidError({ ...validError, minimumVolume: checkPositiveNumber(e.target.value) }) }}
                    variant="outlined"
                    inputProps={{ maxLength: 6 }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack>
                  <label>*Maximum Volume (CBM)</label>
                  <TextField
                    className="mb-16"
                    type="text"
                    name="maximumVolume"
                    required
                    value={maximumVolume}
                    error={(checksubmit && !maximumVolume) || validError.maximumVolume ? true : false}
                    helperText={(checksubmit && !maximumVolume) ? "This field is required" : validError.maximumVolume}
                    onChange={(e) => { setMaximumVolume(e.target.value); setValidError({ ...validError, maximumVolume: checkPositiveNumber(e.target.value) }) }}
                    variant="outlined"
                    inputProps={{ maxLength: 6 }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack>
                  <label>*Maximum Volume for Mix (CBM)</label>
                  <TextField
                    className="mb-16"
                    type="text"
                    name="mixedMaxVolume"
                    required
                    value={mixedMaxVolume}
                    error={(checksubmit && !mixedMaxVolume ) || validError.mixedMaxVolume ? true : false}
                    helperText={(checksubmit && !mixedMaxVolume ) ? "This field is required" : validError.mixedMaxVolume}
                    onChange={(e) => { setMixedMaxVolume(e.target.value); setValidError({ ...validError, mixedMaxVolume: checkPositiveNumber(e.target.value) }) }}
                    variant="outlined"
                    inputProps={{ maxLength: 6 }}
                  />
                </Stack>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Stack>
                  <label>Container Weight (KG)</label>
                  <TextField
                    className="mb-16"
                    type="text"
                    name="containerWeight"
                    required
                    value={containerWeight}
                    error={(checksubmit && !containerWeight ) || validError.containerWeight ? true : false}
                    helperText={validError.containerWeight}
                    onChange={(e) => {
                      setContainerWeight(e.target.value);
                      setValidError({ ...validError, containerWeight: e.target.value && (checkNumber(e.target.value) || checkPositiveNumber(e.target.value))})
                    }}
                    variant="outlined"
                    inputProps={{ maxLength: 6 }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack>
                  <label>*Shipping Type</label>
                  <Select name="country"
                      value={(shippingTypeOptions && shippingType) && shippingTypeOptions.filter(obj => shippingType.includes(obj.value))}
                      onChange={(e) => setShippingType(e.value)}
                      className="select"
                      classNamePrefix="select"
                      options={shippingTypeOptions}
                      styles={customStyles(((checksubmit && !shippingType) || validError.shippingType) && "#f44336")}
                  />
                  <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !shippingType) ? "This field is required" : validError.shippingType}</Typography>
                </Stack>
              </Grid>
            </Grid>
          </div>
        </FormControl>
      </div>
    </div>
  )
}

export default ContainerTypeForm